module.exports = __webpack_public_path__ + "static/img/01_10.2b24791.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity20240913/01_10.png
// module id = 9OEw
// module chunks = 0